import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { merchantsListKeys } from "Api/Queries/Merchants/useGetMerchantsQuery";
import {
  type CreateMerchantFacilityDto,
  type MerchantFacilityDto,
  postMerchantsPublicIDFacilities,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export type CreateMerchantFacilityParameters = {
  data: CreateMerchantFacilityDto;
  publicID: string;
};

type Props = {
  onSuccess?: (data: MerchantFacilityDto) => void;
  onError?: () => void;
};

export const useCreateMerchantFacilityMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, publicID }: CreateMerchantFacilityParameters) =>
        postMerchantsPublicIDFacilities(data, publicID),
    ),
    onSuccess: async (data: MerchantFacilityDto) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: merchantKeys.all }),
        queryClient.invalidateQueries({ queryKey: merchantsListKeys.all }),
      ]);
      onSuccess?.(data);
    },
    onError,
  });
};
